
let ErrorPromptSingleton
if (global.document) {
  const Honeybadger = require('honeybadger-js')

  const config = {
    apiKey: __SERVER_VAR_HONEYBADGER_JS_KEY__, // eslint-disable-line no-undef
    environment: __SERVER_VAR_NODE_ENV__, // eslint-disable-line no-undef
    revision: __SERVER_VAR_REVISION_HASH__ // eslint-disable-line no-undef
  }
  Honeybadger.configure(config)

  ErrorPromptSingleton = Honeybadger
  global.onerror = (message, source, lineNumber, colNumber, error) => {
    const errorInfo = {
      message: message,
      context: {source, lineNumber, colNumber}
    }
    // Temporarily disabled
    // if (error) { ErrorPromptSingleton.notify(error, errorInfo) }
    // Log if we caught something, but not on production
    if (config.environment !== 'production') {
      console.log(errorInfo)
    }
    return false
  }
} else {
  ErrorPromptSingleton = {
    notify: (error, context) => {
      console.log(error, context)
    }
  }
}

export default ErrorPromptSingleton



// WEBPACK FOOTER //
// ./assets/js/components/errorLog/ErrorPrompt.jsx